import { ModalProps } from 'types/modal'
import Modal from '@components/shared/Modal'
import Button from '@components/shared/Button'
import { localStorageKey, useLocalStorage } from 'hooks/useLocalStorageState'
import Checkbox from '@components/forms/Checkbox'
import Link from 'next/link'
import { useState, ReactNode, useCallback } from 'react'
import { useWalletModal } from '@solana/wallet-adapter-react-ui'
import { useTranslation, Trans } from 'next-i18next'
import { sleep } from 'utils'

const LinkText = ({
  href,
  children,
}: {
  href: string
  children?: ReactNode
}) => {
  return (
    <Link href={href} target="_blank">
      {children}
    </Link>
  )
}

export const TERMS_OF_USE_KEY = localStorageKey('termsAccepted-0.2', false)

const AcceptTermsModal = ({ isOpen, onClose }: ModalProps) => {
  const { t } = useTranslation('accept-terms')
  const [checked, setChecked] = useState(false)
  const [, setTermsAccepted] = useLocalStorage(TERMS_OF_USE_KEY)
  const { visible, setVisible } = useWalletModal()

  const handleGetStarted = useCallback(async () => {
    setVisible(!visible)
    setTermsAccepted(true)
    await sleep(500)
    onClose()
  }, [onClose, setTermsAccepted, setVisible, visible])

  return (
    <Modal isOpen={isOpen} onClose={onClose} disableOutsideClose hideClose>
      <div className="mb-4 flex flex-col items-center">
        <h2 className="text-center">{t('title')}</h2>
      </div>
      <div className="mt-4 rounded-md bg-th-bkg-2 px-4 py-3">
        <Checkbox
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        >
          <span className="whitespace-normal text-sm">
            <Trans
              i18nKey="accept-text"
              t={t}
              components={{
                termsLink: <LinkText href="/terms-of-use" />,
                privacyLink: <LinkText href="/privacy-policy" />,
              }}
            />
          </span>
        </Checkbox>
      </div>
      <Button
        className="mt-6 w-full"
        disabled={!checked}
        onClick={handleGetStarted}
        size="large"
      >
        {t('get-started')}
      </Button>
    </Modal>
  )
}

export default AcceptTermsModal
